import { ReplaySubject, Subject } from "rxjs";

// Global
const whiteLabelSubject = new ReplaySubject(1);
const evergreenModalClosed = new Subject();
const scheduledPostModalClosed = new Subject();

// Error messages
const errorMessageAddressed = new Subject();
const errorMessageMarkedCompleted = new Subject();

// Generate Captions
const generateCaptionsOpen = new Subject();
const captionsGenerated = new Subject();
const singleCaptionGenerated = new Subject();

// Emojis
const addContentEmoji = new Subject();
const broadcastContentEmoji = new Subject();
const scheduledContentEmoji = new Subject();
const bulkContentEmoji = new Subject();
const contentCommentEmoji = new Subject();

// CaptionAI
const captionAIHistorySubject = new Subject();

// Post Status
const postStatusUpdate$ = new Subject();

// Post Retry Errors
const postRetryErrors$ = new Subject();

// User Updates
const userUpdates$ = new Subject();

// Tag Updates
const tagUpdates$ = new Subject();

// Workspace Updates
const workspaceUpdates$ = new Subject();

// Linked Account Updates
const linkedAccountUpdates$ = new ReplaySubject(1);

// Agency Settings Updates
const settingsUpdate$ = new ReplaySubject(1);

// Hashtags
const hashtagsUpdate$ = new Subject();

// CC Context for Tellium
const updateCCContext$ = new Subject();

// Canva Images
const stockImages$ = new Subject();

// Content Tags
const contentTags$ = new Subject();

// Getting Started Guide
const gettingStartedGuideOpen$ = new ReplaySubject();

// Refresh Credentials
const refreshCredentials$ = new Subject();

// Alerts Info
const alertsUpdate$ = new ReplaySubject();

// User Info Changes
const userInfoChanged$ = new Subject();

// User Info Prompt
const userInfoPromptOpen$ = new Subject();

// Hidden Social Platforms
const hiddenSocialPlatforms$ = new Subject();

export {
  whiteLabelSubject,
  evergreenModalClosed,
  scheduledPostModalClosed,
  errorMessageAddressed,
  errorMessageMarkedCompleted,
  generateCaptionsOpen,
  captionsGenerated,
  singleCaptionGenerated,
  addContentEmoji,
  broadcastContentEmoji,
  scheduledContentEmoji,
  bulkContentEmoji,
  contentCommentEmoji,
  captionAIHistorySubject,
  postStatusUpdate$,
  postRetryErrors$,
  userUpdates$,
  tagUpdates$,
  workspaceUpdates$,
  linkedAccountUpdates$,
  settingsUpdate$,
  hashtagsUpdate$,
  updateCCContext$,
  contentTags$,
  stockImages$,
  gettingStartedGuideOpen$,
  refreshCredentials$,
  alertsUpdate$,
  userInfoChanged$,
  userInfoPromptOpen$,
  hiddenSocialPlatforms$,
};
